import React from "react";
import {axiosCommon} from "../../../util/axiosSetup.js";
import {BASE_URL} from "../../../util/Urls";
import getGeneralError from "../../../util/getGeneralError";
import Footer from "../../../components/Footer";
import Search from "../../../components/Search";
import Card from "../../../components/Card";
import Widget from "../../../components/Widget";
import {
    Paper,
    IconButton,
    TextField, Collapse, Tab, Tooltip
} from "@material-ui/core";
import { MdContentCopy } from "react-icons/md";
import RowsPerPageOptions from "../../../util/RowsPerPageOptions";
import NavHeader from "../../../components/NavHeader";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {Alert} from "@material-ui/lab";
import TabList from "../../../components/TabList";
import { DataGrid, GridToolbarContainer, GridToolbarExport } from "@material-ui/data-grid";
import NoData from "../../../components/NoData";
import TabPanel from "../../../components/TabPanel";
import axios from "axios";
import { formatDateTimeForFileName } from "../../../util/dateTime";

export default class ProductIndentifierListPage extends React.Component {
    constructor() {
        super();
        this.state = {
            tabIndex: 0,
            keyword: "",
            products: [],
            toppings: [],
            availableCategories: [],
            selectedCategories: [],
            count: 0,
            error: null,
            productRowsPerPage: RowsPerPageOptions.defaultPageSize,
            toppingRowsPerPage: RowsPerPageOptions.defaultPageSize,
            page: 0,
            isLoading: false,
            productColumns: [
                {field: 'copy', headerName: '', align: 'center', headerAlign: 'center', width: 50, renderCell: this.renderIdAndCopy},
                {field: 'id', headerName: 'ID', align: 'center', headerAlign: 'center', width: 90},
                {field: 'name', headerName: 'Termék', align: 'left', headerAlign: 'left', minWidth: 300,},
                {field: 'category', headerName: 'Kategória', align: 'left', headerAlign: 'left', minWidth: 200,},
                {field: 'description', headerName: 'Leírás', align: 'left', headerAlign: 'left', minWidth: 200, flex: 1,}],
            productRows: [],
            toppingColumns: [
                {field: 'copy', headerName: '', align: 'center', headerAlign: 'center', width: 50, renderCell: this.renderIdAndCopy},
                {field: 'id', headerName: 'ID', align: 'center', headerAlign: 'center', width: 90},
                {field: 'name', headerName: 'Feltét', align: 'left', headerAlign: 'left', minWidth: 300,},
                {field: 'description', headerName: 'Leírás', align: 'left', headerAlign: 'left', minWidth: 200, flex: 1,}],
            toppingRows: [],
            isCopySuccesful: false,
            isCopyFail: false,
        };
        this.timeout = 0
    }

    componentDidMount() {
        this.setState({isLoading: true, })

        axiosCommon(`${BASE_URL}/api/categories`)
        .then(response => this.setState({ availableCategories: response.data.items }))
        .catch(error => this.setState({ error }))

        axiosCommon(`${BASE_URL}/api/toppings?`)
        .then(response => {
            const toppings = response.data.items

            const toppingRows = toppings.map((e, i) => {
                return {
                    copy: e.id,
                    id: e.id,
                    name: e.name,
                    description: e.description,
                }
            })
            this.setState({ toppings, toppingRows })
        })
        .catch(error => this.setState({ error }))

        const queryParams = { deleted: false, }
        axiosCommon(`${BASE_URL}/api/products?`,{ params: queryParams })
        .then(response => {
            const products = response.data.items
            const productRows = products.map((e, i) => {
                return {
                    copy: e.id,
                    id: e.id,
                    name: e.name,
                    category: e.category.name,
                    description: e.description,
                }
            })
            this.setState({ products, productRows})
        })
        .catch(error => {
            if (!axios.isCancel(error)) this.setState({ error })
        })
        .finally(() => { this.setState({isLoading: false, })})
    }

    refreshData = () => {
        let filteredProducts = this.state.products
        let filteredToppings = this.state.toppings

        const categoryIds = this.state.selectedCategories.map(c => c.id);
        if(categoryIds.length > 0) {
            filteredProducts = filteredProducts.filter(product =>
                product.category && categoryIds.includes(product.category.id)
            )
        }

        if (this.state.keyword?.length > 0){
            const keyword = this.state.keyword.toLowerCase()
            filteredProducts = filteredProducts.filter(product =>
                product.name.toLowerCase().includes(keyword) ||
                product.id.toString().includes(keyword) ||
                product.description?.toLowerCase().includes(keyword)
            )

            filteredToppings = filteredToppings.filter(topping =>
                topping.name.toLowerCase().includes(keyword) ||
                topping.id.toString().includes(keyword) ||
                topping.description?.toLowerCase().includes(keyword)
            )
        }

        const productRows = filteredProducts.map((e, i) => {
            return {
                copy: e.id,
                id: e.id,
                name: e.name,
                category: e.category.name,
                description: e.description,
            }
        })

        const toppingRows = filteredToppings.map((e, i) => {
            return {
                copy: e.id,
                id: e.id,
                name: e.name,
                description: e.description,
            }
        })

        this.setState({productRows, toppingRows})
    };

    setKeyword = (event) => this.setState({ keyword: event.target.value, page: 0, }, () => this.refreshData())

    onChangeCategoryFiler = (event, value) => this.setState({ selectedCategories: value, page: 0, }, () => this.refreshData())


    renderIdAndCopy = (params) => {
        return <Tooltip title="Másolás a vágólapra" placement="top">
            <IconButton aria-label="copy" onClick={() => this.handleCopy(params.value)}>
                <MdContentCopy />
            </IconButton>
        </Tooltip>
    }

    handleCopy = async (value) => {
        if(this.timeout) clearTimeout(this.timeout)
        try {
            await navigator.clipboard.writeText(value);
            this.setState({isCopySuccesful: true, isCopyFail: false})
        } catch (err) {
            this.setState({isCopySuccesful: false, isCopyFail: true})
        }
        this.timeout = setTimeout(() => this.setState({ isCopySuccesful: false, isCopyFail: false }),3000)
    };

    renderList = () => {
        return this.state.error
            ? <section className="error">{getGeneralError(this.state.error)}</section>
            : <>
                <TabList
                    value={this.state.tabIndex}
                    onChange={(event, newValue) => {
                        this.setState({tabIndex: newValue});
                    }}
                >
                    <Tab label="Termékek"/>
                    <Tab label="Feltét csoportok"/>
                </TabList>

                <TabPanel value={this.state.tabIndex} index={0}>
                    <Widget>
                        <Card title="Szűrés kategóriák alapján">
                            <Autocomplete
                                multiple
                                onChange={this.onChangeCategoryFiler}
                                name="categoryFilter"
                                fullWidth
                                noOptionsText="Nincs ilyen tétel"
                                options={this.state.availableCategories}
                                getOptionLabel={(option) => option === "" ? "" : option.name}
                                getOptionSelected={(option, value) => option.id === value.id}
                                value={this.state.selectedCategories || ""}
                                renderInput={(params) =>
                                    <TextField {...params} label="Kategória" variant="outlined" />
                                }
                            />
                        </Card>
                        <div className="m-8"/>
                        <Card title="Keresés a névben / ID-ban / leírásban">
                            <Search
                                setKeyword={this.setKeyword}
                                refreshData={this.refreshData}
                                value={this.state.keyword}
                            />
                        </Card>
                    </Widget>

                    <Paper className="mt-16 mb-16">
                        <DataGrid
                            columns={this.state.productColumns}
                            rows={this.state.productRows}
                            disableSelectionOnClick
                            disableColumnMenu
                            autoHeight
                            pagination
                            loading={this.state.isLoading}
                            rowsPerPageOptions={RowsPerPageOptions.items}
                            pageSize={this.state.productRowsPerPage}
                            onPageSizeChange={(entry) => this.setState({ productRowsPerPage: parseInt(entry, 10) })}
                            components={{
                                Toolbar: () => {
                                    return (
                                        <GridToolbarContainer>
                                            <GridToolbarExport
                                                csvOptions={{
                                                    fields: ['id', 'name', 'category', 'description'],
                                                    fileName: `Bythepay Termék Azonosítók - Termékek ${formatDateTimeForFileName()}`,
                                                    utf8WithBom: true,
                                                    delimiter: ';',
                                                }}/>
                                        </GridToolbarContainer>
                                    );
                                },
                                NoRowsOverlay: NoData,
                            }}
                        />
                    </Paper>
                </TabPanel>

                <TabPanel value={this.state.tabIndex} index={1}>
                    <Widget>
                        <div className="flex-1"/>
                        <div className="m-8"/>
                        <Card title="Keresés a névben / ID-ban / leírásban">
                            <Search
                                setKeyword={this.setKeyword}
                                refreshData={this.refreshData}
                                value={this.state.keyword}
                            />
                        </Card>
                    </Widget>

                    <Paper className="mt-16 mb-16">
                        <DataGrid
                            columns={this.state.toppingColumns}
                            rows={this.state.toppingRows}
                            disableSelectionOnClick
                            disableColumnMenu
                            autoHeight
                            pagination
                            loading={this.state.isLoading}
                            rowsPerPageOptions={RowsPerPageOptions.items}
                            pageSize={this.state.toppingRowsPerPage}
                            onPageSizeChange={(entry) => this.setState({ toppingRowsPerPage: parseInt(entry, 10) })}
                            components={{
                                Toolbar: () => {
                                    return (
                                        <GridToolbarContainer>
                                            <GridToolbarExport
                                                csvOptions={{
                                                    fields: ['id', 'name', 'category', 'description'],
                                                    fileName: `Bythepay Termék Azonosítók - Feltét csoportok ${formatDateTimeForFileName()}`,
                                                    utf8WithBom: true,
                                                    delimiter: ';',
                                                }}/>
                                        </GridToolbarContainer>
                                    );
                                },
                                NoRowsOverlay: NoData,
                            }}
                        />
                    </Paper>
                </TabPanel>
            </>
    }

    render() {
        return <>
            <section className="main-content">
                <section className="main-content-body">
                    <NavHeader changeSidebarToggled={this.props.changeSidebarToggled}/>
                    {this.renderList()}

                    <Collapse in={this.state.isCopySuccesful} style={{position: 'fixed', bottom: '20px', right: '20px', zIndex: 1000}}>
                        <Alert severity="success" onClose={() => this.setState({isCopySuccesful: false})}>
                            Az azonosítót a vágólapra másoltuk.
                        </Alert>
                    </Collapse>

                    <Collapse in={this.state.isCopyFail} style={{position: 'fixed', bottom: '20px', right: '20px', zIndex: 1000}}>
                        <Alert severity="error" onClose={() => this.setState({isCopyFail: false})}>
                            Az azonosítót nem tudtuk a vágolapra másolni.
                        </Alert>
                    </Collapse>

                </section>
                <Footer/>
            </section>
        </>;
    }
}
